// @flow

import sharedDialogStyles from '../../Styles/SharedDialogStyles';

/**
 * Staff Invitation Home styles following MUI 5 patterns
 * Exports a plain object with style keys as functions (theme) => ({ ... })
 */

const staffInvitationHomeStyles = {
  headerLogo: (theme) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    textAlign: 'center'
  }),
  contentCtr: (theme) => ({
    position: 'relative',
    maxWidth: 540,
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    margin: '0 auto',
    textAlign: 'center',
    zIndex: 0
  }),
  formTitle: (theme) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(6)
  }),
  // Form container for the entire form
  formContainer: (theme) => ({
    width: '100%',
    maxWidth: '100%'
  }),
  // Input styling to match standard pattern
  inputForm: (theme) => ({
    width: '100%',
    height: '45px',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5)
  }),
  inputPhoneForm: (theme) => ({
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    '& > div': {
      width: '100%',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(0.5)
    },
    '& > label.MuiInputLabel-shrink': {
      transform: 'translate(0, -1.5px) scale(0.75)',
      transformOrigin: 'top left',
      color: theme.palette.text.secondary
    }
  }),
  // Submit button styling
  submitBtn: (theme) => ({
    marginTop: theme.spacing(3),
    width: '100%',
    padding: theme.spacing(1.5, 4),
    fontWeight: 600
  }),
  // Loading/info text
  loadingText: (theme) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }),
  // Error box with bottom margin to separate from security info
  errorWithMargin: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  // Security info text
  securityInfo: (theme) => ({
    marginTop: theme.spacing(4),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    textAlign: 'center'
  })
};

// Combine with shared dialog styles for consistency
const styles = {
  ...sharedDialogStyles,
  ...staffInvitationHomeStyles
};

export default styles;